import { useGetMe } from '@/api/me'
import pagePath from '@/utils/pagePath'
import { Navigate, Outlet } from 'react-router'

type AccessibleRole = 'UNAUTHORIZED' | 'AUTHORIZED' | 'ALL'

type AccessControlRouteProps = {
  accessibleRole?: AccessibleRole
}

const AccessControlRoute = ({ accessibleRole = 'ALL' }: AccessControlRouteProps) => {
  const { data: user, isFetched } = useGetMe()

  if (!isFetched || accessibleRole === 'ALL') return <Outlet />

  if (accessibleRole === 'AUTHORIZED' && !user?.name)
    return <Navigate to={pagePath.login} replace />

  if (accessibleRole === 'UNAUTHORIZED' && user?.name)
    return <Navigate to={pagePath.channelVideos('temp')} replace />

  return <Outlet />
}

export default AccessControlRoute
